import ROUTE from '@app/navigationApp/routes';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { RootState } from '@app/store/newstore';
import {APPLICATION_STATUS, getParameters, removeUrlWithoutReload} from '@app/utils/utils';
import { useEffect } from 'react';
import {View, ActivityIndicator,Platform} from 'react-native';
import { phonePayRoutes } from '@voltmoney/micro-frontend/lib/configs/utils';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import { LENDER_ID } from '@app/constants/platformPartners';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updatePartnerParams } from '@app/store/slices/platformSlice';


export enum TARGET_PAGES {
    MANAGE_LIMIT= 'manageLimit',
    ACCOUNT = 'account',
    REPAYMENT = 'payment',
    WITHDRAW = 'withdraw',
    FORECLOSURE = 'foreclosure',
    TRANSACTION = 'transaction',
}

const TARGET_ROUTES = {
    [TARGET_PAGES.ACCOUNT]: ROUTE.USER_PROFILE,
    [TARGET_PAGES.REPAYMENT]: ROUTE.FLEXI_PAY,
    [TARGET_PAGES.WITHDRAW]: ROUTE.WITHDRAW_AMOUNT,
    [TARGET_PAGES.FORECLOSURE]: ROUTE.HOW_TO_CLOSE_ACCOUNT,
}

// const

const LoaderLMS = ({navigation}) => {
    const userDetails = useAppSelector((state: RootState) => state.auth?.userDetails);
    const creditDetails = useAppSelector((state: RootState) => state.auth?.creditDetails);
    const platformParams = useAppSelector((state: RootState) => state.platformParams);
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail===null;
    const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
    const {showHome,plj,plk,platform,isFromPhonePe,isFromBajaj,redirect,isPLJ,target,takeToFlexiPay} = platformParams
    const dispatch = useAppDispatch()

     const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : {};
     const isPgCallback = params?.uid || '';
    const shouldRedirect = params?.redirect || false;
    const isBajajLender = userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()

    const TARGET_ROUTES = {
        [TARGET_PAGES.ACCOUNT]: ROUTE.USER_PROFILE,
        [TARGET_PAGES.REPAYMENT]: ROUTE.FLEXI_PAY,
        [TARGET_PAGES.WITHDRAW]: ROUTE.WITHDRAW_AMOUNT,
        [TARGET_PAGES.FORECLOSURE]: isBajajLender ? ROUTE.OLD_FORECLOSURE : ROUTE.HOW_TO_CLOSE_ACCOUNT,
    }

    useEffect(() => {
        if(Platform.OS === 'web' && platformParams?.isParamsUpdated &&userDetails!==null){
            const skipToEnterEmail = ['JUPITER','BHARAT_PE','PARKPLUS','TATADIGITAL','BHARAT_PE_2','PARKPLUS','PHONEPE','SDK_INVESTWELL','LARK','FLIPKART'].includes(platform);
            const isFromBharatPe = platform==='BHARAT_PE';
            const isFromSecondBharatPe = platform==='BHARAT_PE_2';
        setTimeout(() => {
            if(target){
                const typedTarget = target as keyof typeof TARGET_ROUTES;
                if(TARGET_ROUTES[typedTarget]){
                    navigation.reset({
                        routes: [{ name: ROUTE.HOME }, { name: TARGET_ROUTES[typedTarget] }],
                    });
                    dispatch(updatePartnerParams({"target": ""}))
                    removeUrlWithoutReload("target")
                }
                else{
                    navigation.navigate(ROUTE.HOME);
                }
                return
            }
            else if (isPgCallback && shouldRedirect) {
                navigation.navigate(ROUTE.PAYMENT_LOADER);
            }
            else if(isPgCallback){
                navigation.navigate(ROUTE.PAYMENT_STATUS,{isPgCallback});
                return
            }
            else if(!showHome){
                if(userEmailNotExist){
                    navigation.navigate(Boolean(plj) || skipToEnterEmail ? ROUTE.ENTER_EMAIL :ROUTE.VERIFY_EMAIL);
                }
                else if(currentStepName){
                    if(isFromPhonePe || isFromSecondBharatPe || isFromBharatPe){
                        if(phonePayRoutes.includes(currentStepName)){
                            navigation.navigate(currentStepName);
                        }
                        else{
                            navigation.navigate('SPLASH_SCREEN');
                        }
                    }
                    else{
                        navigation.navigate(currentStepName);
                    }
                }
                else if(isLMSUser){
                    navigation.navigate(ROUTE.HOME);
                }
                else{
                    navigation.navigate('SPLASH_SCREEN');
                }   
            }
            else {
                if(Boolean(plk) && userEmailNotExist){
                    navigation.reset({
                        routes: [{ name: ROUTE.HOME }, { name: ROUTE.ENTER_EMAIL }],
                      });
                } else if (userEmailNotExist && isPLJ) {
                        navigation.navigate(ROUTE.ENTER_EMAIL)
                } else if (takeToFlexiPay){
                    navigation.reset({
                        routes: [{ name: ROUTE.HOME }, { name: ROUTE.FLEXI_PAY}],
                    });
                } 
                else {
                    const applicationStatus = userDetails?.linkedApplications[0]?.applicationState
                    if(applicationStatus === APPLICATION_STATUS.DENIED || applicationStatus === APPLICATION_STATUS.BLOCKED) {
                        navigation.navigate('SPLASH_SCREEN');
                    } else {
                        navigation.navigate(ROUTE.HOME);
                    }
                }
            }

        }, 300);
      }
      }, [platformParams?.isParamsUpdated]);
    return (
    <View style={{ backgroundColor: 'white', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {/* <VoltLogoNew/> */}
        <ActivityIndicator size={12} color="#1434CB" />
    </View>
  );
}
export default LoaderLMS;